import { NavLink } from "react-router-dom";
import "./Topbar.css";

function navlinkStyle({ isActive }) {
  let activeStyle = {
    borderStyle: "solid",
    borderRadius: "15px",
    borderWidth: "2px",
    borderColor: "#000000",
  };
  // return isActive ? {...style,...activeStyle} : style;
  return { padding: "0.5rem", ...(isActive && activeStyle) };
}

function Topbar() {
  return (
    <div className="topbar">
      <NavLink to="/search" style={navlinkStyle}>
        Search
      </NavLink>
      <NavLink to="/bookings" style={navlinkStyle}>
        My Bookings
      </NavLink>
    </div>
  );
}
export default Topbar;
